<template>
  <a-drawer width="95%" :visible="open" @close="onClose">
    <template slot="title">
      <span>{{ formTitle }}</span>
    </template>

    <div class="order-detail-wrap">
      <!-- 订单状态步骤条 -->
      <a-steps
        v-if="form.status != null"
        class="order-status-step"
        :current="orderStatusStepCurrent"
        :status="orderStatusStepStatus"
      >
        <a-step title="接单中" />
        <a-step title="待服务" />
        <a-step title="服务中" />
        <a-step title="已完成" />
        <a-step title="售后中" />
        <a-step title="已取消" />
      </a-steps>

      <!-- 订单信息 -->
      <div class="order-info-card">
        <div class="order-info-card__title">订单信息</div>
        <div class="detail-grid">
          <div class="detail-row"><span class="detail-label">招工标题：</span><span class="detail-value">{{ form.title || '-' }}</span></div>
          <div class="detail-row" v-if="form.picture">
            <span class="detail-label">视频/图片：</span>
            <span class="detail-value"><a @click="showMediaModal = true">查看</a></span>
          </div>
          <div class="detail-row"><span class="detail-label">订单编号：</span><span class="detail-value">{{ form.orderNo || '-' }}</span></div>
          <div class="detail-row">
            <span class="detail-label">订单类型：</span>
            <span class="detail-value">
              <a-tag v-if="form.type === 0" color="blue">找个人</a-tag>
              <a-tag v-else-if="form.type === 1" color="green">找公司</a-tag>
              <span v-else>-</span>
            </span>
          </div>
          <div class="detail-row"><span class="detail-label">工种：</span><span class="detail-value">{{ form.categoryName || form.category || '-' }}</span></div>
          <div class="detail-row"><span class="detail-label">工作地点：</span><span class="detail-value">{{ form.workLocation || '-' }}</span></div>
          <div class="detail-row"><span class="detail-label">详细地址：</span><span class="detail-value detail-value--ellipsis" :title="form.address">{{ form.address || '-' }}</span></div>
          <div class="detail-row">
            <span class="detail-label">计价方式：</span>
            <span class="detail-value">
              <span v-if="form.pricingMethod === 0">议价</span>
              <span v-else-if="form.pricingMethod === 1">按时计价</span>
              <span v-else-if="form.pricingMethod === 2">按天计价</span>
              <span v-else-if="form.pricingMethod === 3">按量计价</span>
              <span v-else-if="form.pricingMethod === 4">一口价</span>
              <span v-else-if="form.pricingMethod === 5">{{ form.unit === '天' ? '按天计价' : '按时计价' }}</span>
              <span v-else>-</span>
            </span>
          </div>
          <div class="detail-row"><span class="detail-label">金额/单位：</span><span class="detail-value">{{ moneyUnitDisplay }}</span></div>
          <div class="detail-row" v-if="form.pricingMethod === 3"><span class="detail-label">人均产量要求：</span><span class="detail-value">{{ form.perCapitaProduction || '-' }}</span></div>
          <div class="detail-row"><span class="detail-label">工作开始时间：</span><span class="detail-value">{{ workStartTimeDisplay }}</span></div>
          <div class="detail-row"><span class="detail-label">工作结束时间：</span><span class="detail-value">{{ workEndTimeDisplay }}</span></div>
          <div class="detail-row"><span class="detail-label">每天时段：</span><span class="detail-value">{{ dailyWorkTimeDisplay }}</span></div>
          <div class="detail-row" v-if="firstDayWorkTimeDisplay"><span class="detail-label">当天时段：</span><span class="detail-value">{{ firstDayWorkTimeDisplay }}</span></div>
          <div class="detail-row"><span class="detail-label">人未满是否正常开工：</span><span class="detail-value">{{ startWorkIfUnderstaffedDisplay }}</span></div>
          <div class="detail-row"><span class="detail-label">师傅人数：</span><span class="detail-value">{{ form.numberOfWorkers != null ? form.numberOfWorkers : '-' }}人</span></div>
          <div class="detail-row" v-if="form.genderRequirements === 1 || form.genderRequirements === 2"><span class="detail-label">男/女：</span><span class="detail-value">{{ (form.man != null ? form.man : 0) }} / {{ (form.woman != null ? form.woman : 0) }}</span></div>
          <div class="detail-row">
            <span class="detail-label">性别要求：</span>
            <span class="detail-value">
              <span v-if="form.genderRequirements === 0">不限</span>
              <span v-else-if="form.genderRequirements === 1">男</span>
              <span v-else-if="form.genderRequirements === 2">女</span>
              <span v-else>-</span>
            </span>
          </div>
          <div class="detail-row"><span class="detail-label">年龄要求：</span><span class="detail-value">{{ ageRangeDisplay }}</span></div>
          <div class="detail-row"><span class="detail-label">优惠金额：</span><span class="detail-value">{{ form.discountAmount != null ? form.discountAmount : '-' }}</span></div>
          <div class="detail-row"><span class="detail-label">支付金额：</span><span class="detail-value">{{ form.payAmount != null ? '¥' + Number(form.payAmount).toFixed(2) : '-' }}</span></div>
          <div class="detail-row">
            <span class="detail-label">支付类型：</span>
            <span class="detail-value">
              <a-tag v-if="form.payType === 0" color="gold">金币支付</a-tag>
              <a-tag v-else-if="form.payType === 1" color="green">微信</a-tag>
              <a-tag v-else-if="form.payType === 2" color="blue">支付宝</a-tag>
              <span v-else>-</span>
            </span>
          </div>
          <div class="detail-row"><span class="detail-label">支付时间：</span><span class="detail-value">{{ parseTime(form.payTime) || '-' }}</span></div>
          <div class="detail-row"><span class="detail-label">是否开票：</span><span class="detail-value">{{ form.invoicing === 1 ? '是' : (form.invoicing === 0 ? '否' : '-') }}</span></div>
          <div class="detail-row"><span class="detail-label">查看次数：</span><span class="detail-value">{{ form.watchNum != null ? form.watchNum : '-' }}</span></div>
          <div class="detail-row"><span class="detail-label">创建时间：</span><span class="detail-value">{{ parseTime(form.createTime) || '-' }}</span></div>
        </div>

        <!-- 内容描述 -->
        <div class="detail-row detail-row--block content-desc-block">
          <span class="detail-label">内容描述：</span>
          <div v-if="form.content" class="detail-value order-detail-content" v-html="sanitizeRichText(form.content)"></div>
          <span v-else class="detail-value">-</span>
        </div>
      </div>

      <!-- 雇主信息：a-row/a-col 布局 -->
      <div class="order-info-card order-info-card--employer">
        <div class="order-info-card__title">雇主信息</div>
        <a-row type="flex" align="middle" justify="start" :gutter="8" class="employer-row">
          <a-col :span="4" class="employer-col employer-col--avatar">
            <a-avatar
              v-if="form.userAvatar"
              :src="form.userAvatar"
              :size="64"
              shape="square"
              class="employer-avatar"
              @click.native="previewImage(form.userAvatar)"
            />
            <a-avatar v-else :size="64" shape="square" class="employer-avatar employer-avatar--placeholder">
              {{ (form.userNickname || form.userName || '-').toString().charAt(0) }}
            </a-avatar>
          </a-col>
          <a-col :span="5" class="employer-col">
            <div class="detail-row"><span class="detail-label">昵称：</span><span class="detail-value">{{ form.userNickname || form.userName || '-' }}</span></div>
            <div class="detail-row"><span class="detail-label">联系人姓名：</span><span class="detail-value">{{ form.contactPersonName != null ? form.contactPersonName : '-' }}</span></div>
          </a-col>
          <a-col :span="5" class="employer-col">
            <div class="detail-row"><span class="detail-label">手机号：</span><span class="detail-value">{{ form.userMobile || '-' }}</span></div>
            <div class="detail-row"><span class="detail-label">联系方式：</span><span class="detail-value">{{ form.contactPersonPhone != null ? form.contactPersonPhone : '-' }}</span></div>
          </a-col>
          <a-col :span="6" class="employer-col employer-col--credit">
            <div class="detail-row detail-row--align-center">
              <span class="detail-value">
                <a-progress
                  v-if="form.userCreditScore != null && form.userCreditScore !== ''"
                  type="circle"
                  :percent="userCreditScorePercent"
                  :stroke-color="userCreditScoreStrokeColor"
                  :width="80"
                  :format="formatCreditScore"
                />
                <span v-else>-</span>
              </span>
            </div>
          </a-col>
          <a-col :span="4" class="employer-col employer-col--rate">
            <div class="detail-row detail-row--align-center">
              <span class="detail-label">评价分：</span>
              <span class="detail-value employer-rate-wrap">
                <span class="employer-rate-stars" aria-hidden="true">
                  <span
                    v-for="i in 5"
                    :key="i"
                    class="employer-rate-star"
                    :class="{ 'is-full': userCommentScoreRate >= i, 'is-half': userCommentScoreRate >= i - 0.5 && userCommentScoreRate < i }"
                  >
                    <span v-if="userCommentScoreRate >= i" class="star-full">★</span>
                    <span v-else-if="userCommentScoreRate >= i - 0.5" class="star-half">★</span>
                    <span v-else class="star-empty">☆</span>
                  </span>
                </span>
                <span class="detail-value">{{ (form.userCommentScore != null && form.userCommentScore !== '') ? form.userCommentScore + '分' : '-' }}</span>
              </span>
            </div>
          </a-col>
        </a-row>
      </div>
      <a-tabs type="card" v-if="form.status > 0" class="order-detail-tabs">
        <a-tab-pane key="0" tab="师傅信息">
          <MasterInfo :order-id="form.id" />
        </a-tab-pane>
        <a-tab-pane key="1" tab="支付信息">
          <PaymentInfo :order-id="form.id" />
        </a-tab-pane>
        <a-tab-pane key="2" tab="打卡记录">
          <CheckInRecord :order-id="form.id" />
        </a-tab-pane>
        <a-tab-pane key="3" tab="加班记录">
          <OvertimeRecord :order-id="form.id" />
        </a-tab-pane>
        <a-tab-pane key="4" tab="辅材/打赏">
          <MaterialReward :order-id="form.id" />
        </a-tab-pane>
        <a-tab-pane key="5" tab="保险信息">
          <InsuranceInfo :order-id="form.id" :insurance-info="form.insuranceInfo" />
        </a-tab-pane>
        <a-tab-pane key="6" tab="售后信息">
          <AfterSalesInfo :order-id="form.id" />
        </a-tab-pane>
        <a-tab-pane key="7" tab="订单评价">
          <OrderEvaluation :order-id="form.id" />
        </a-tab-pane>
      </a-tabs>
      <!-- 发票图片 -->
      <div class="order-detail-media" v-if="form.platformInvoicingPicture || form.invoicePicture">
        <div v-if="form.platformInvoicingPicture" class="invoice-img-wrap">
          <span class="invoice-label">平台发票：</span>
          <img
            :src="form.platformInvoicingPicture"
            class="invoice-img"
            alt="平台发票"
            @click="previewImage(form.platformInvoicingPicture)"
          />
        </div>
        <div v-if="form.invoicePicture" class="invoice-img-wrap">
          <span class="invoice-label">用户发票：</span>
          <img
            :src="form.invoicePicture"
            class="invoice-img"
            alt="用户发票"
            @click="previewImage(form.invoicePicture)"
          />
        </div>
      </div>
    </div>

    <!-- 视频/图片查看弹窗 -->
    <a-modal
      title="视频/图片"
      :visible="showMediaModal"
      :footer="null"
      width="800px"
      @cancel="showMediaModal = false"
    >
      <video
        v-if="showMediaModal && isVideo(form.picture)"
        :src="form.picture"
        controls
        style="width: 100%; max-height: 480px; border-radius: 4px; background: #000;"
      />
      <img
        v-else-if="showMediaModal && form.picture"
        :src="form.picture"
        style="width: 100%; max-height: 70vh; object-fit: contain; border-radius: 4px; cursor: pointer;"
        @click="previewImage(form.picture)"
      />
    </a-modal>

    <!-- 下部分：操作区（可修改状态） -->
    <!-- <div class="order-detail-footer">
      <a-divider>操作</a-divider>
      <a-form-model ref="form" :model="form" :rules="footerRules" layout="inline">
        <a-form-model-item label="修改状态" prop="status">
          <a-select v-model="form.status" placeholder="选择状态" style="width: 140px;">
            <a-select-option :value="0">接单中</a-select-option>
            <a-select-option :value="1">服务中</a-select-option>
            <a-select-option :value="2">已完成</a-select-option>
            <a-select-option :value="3">售后中</a-select-option>
            <a-select-option :value="4">已取消</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
          <a-button style="margin-left: 8px" @click="cancel">关闭</a-button>
        </a-form-model-item>
      </a-form-model>
    </div> -->
  </a-drawer>
</template>

<script>
import { getOrder, updateOrder } from '@/api/order/order'
import { getUser as getBizUser } from '@/api/biz/user'
import { sanitizeRichText } from '@/utils/sanitize'
import MasterInfo from './detail-tabs/MasterInfo'
import PaymentInfo from './detail-tabs/PaymentInfo'
import CheckInRecord from './detail-tabs/CheckInRecord'
import OvertimeRecord from './detail-tabs/OvertimeRecord'
import MaterialReward from './detail-tabs/MaterialReward'
import InsuranceInfo from './detail-tabs/InsuranceInfo'
import AfterSalesInfo from './detail-tabs/AfterSalesInfo'
import OrderEvaluation from './detail-tabs/OrderEvaluation'

export default {
  name: 'CreateForm',
  components: {
    MasterInfo,
    PaymentInfo,
    CheckInRecord,
    OvertimeRecord,
    MaterialReward,
    InsuranceInfo,
    AfterSalesInfo,
    OrderEvaluation
  },
  props: {},
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      form: {
        id: null,
        userId: null,
        type: null,
        status: 0,
        title: null,
        picture: null,
        content: null,
        category: null,
        categoryName: null,
        longitude: null,
        latitude: null,
        provinceCode: null,
        cityCode: null,
        areaCode: null,
        workLocation: null,
        address: null,
        pricingMethod: null,
        workStartTime: null,
        workEndTime: null,
        workTime: null,
        invoicing: null,
        invoiceId: null,
        invoicePicture: null,
        platformInvoicingPicture: null,
        money: null,
        unit: null,
        perCapitaProduction: null,
        numberOfWorkers: null,
        genderRequirements: null,
        ageRequirements: null,
        discountAmount: null,
        payAmount: null,
        payType: null,
        payTime: null,
        watchNum: null,
        createTime: null,
        remark: null,
        userName: null,
        userAvatar: null,
        userNickname: null,
        userMobile: null,
        contactPersonName: null,
        contactPersonPhone: null,
        userCreditScore: null,
        userCommentScore: null,
        insuranceInfo: null,
        man: null,
        woman: null,
        startWorkIfUnderstaffed: null
      },
      formType: 1,
      open: false,
      showMediaModal: false,
      footerRules: {
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  computed: {
    orderStatusStepCurrent () {
      const s = this.form.status
      if (s == null || s < 0) return 0
      // status → step 映射: 0→0(接单中) 5→1(待服务) 1→2(服务中) 2→3(已完成) 3→4(售后中) 4→5(已取消)
      const map = { 0: 0, 5: 1, 1: 2, 2: 3, 3: 4, 4: 5 }
      return map[s] != null ? map[s] : 0
    },
    orderStatusStepStatus () {
      return this.form.status === 4 ? 'error' : 'process'
    },
    userCreditScorePercent () {
      const s = this.form.userCreditScore
      if (s == null) return 0
      return Math.min(100, Math.max(0, Number(s)))
    },
    /** 信用分圆形进度条颜色：90+ 绿色、80-90 黄色、80 以下红色 */
    userCreditScoreStrokeColor () {
      const s = this.form.userCreditScore
      if (s == null || s === '') return '#1890ff'
      const n = Number(s)
      if (n >= 90) return '#52c41a'
      if (n >= 80) return '#faad14'
      return '#f5222d'
    },
    userCommentScoreRate () {
      const s = this.form.userCommentScore
      if (s == null || s === '') return 0
      const n = Number(s)
      if (Number.isNaN(n)) return 0
      return n <= 5 ? n : n / 20
    },
    moneyUnitDisplay () {
      if (this.form.pricingMethod === 0) return this.form.money != null ? this.form.money : '-'
      if (this.form.money == null) return '-'
      const u = this.form.pricingMethod
      if (u === 1) return `${this.form.money} 元/时`
      if (u === 2) return `${this.form.money} 元/天`
      if (u === 3) return `${this.form.money} 元/${this.form.unit || '件'}`
      if (u === 4) return `${this.form.money} 元`
      if (u === 5) return this.form.unit === '天' ? `${this.form.money} 元/天` : `${this.form.money} 元/时`
      return String(this.form.money)
    },
    workStartTimeDisplay () {
      if (!this.form.workStartTime) return '-'
      return this.parseTime(this.form.workStartTime, '{y}年{m}月{d}日') || '-'
    },
    workEndTimeDisplay () {
      if (!this.form.workEndTime) return '-'
      return this.parseTime(this.form.workEndTime, '{y}年{m}月{d}日') || '-'
    },
    dailyWorkTimeDisplay () {
      if (!this.form.workTime) return '-'
      try {
        const list = JSON.parse(this.form.workTime)
        if (!Array.isArray(list) || list.length === 0) return this.form.workTime
        const dailyItems = list.filter(t => !t || !t.isFirstDay)
        if (dailyItems.length === 0) return '-'
        return dailyItems.map(t => `${t.startTime || ''}-${t.endTime || ''}`).filter(Boolean).join('，') || '-'
      } catch (e) {
        return this.form.workTime
      }
    },
    firstDayWorkTimeDisplay () {
      if (!this.form.workTime) return ''
      try {
        const list = JSON.parse(this.form.workTime)
        if (!Array.isArray(list) || list.length === 0) return ''
        const firstDayItems = list.filter(t => t && t.isFirstDay)
        if (firstDayItems.length === 0) return ''
        return firstDayItems.map(t => `${t.startTime || ''}-${t.endTime || ''}`).filter(Boolean).join('，') || ''
      } catch (e) {
        return ''
      }
    },
    startWorkIfUnderstaffedDisplay () {
      if (this.form.startWorkIfUnderstaffed == null) return '-'
      return this.form.startWorkIfUnderstaffed === 1 ? '是' : '否'
    },
    ageRangeDisplay () {
      if (!this.form.ageRequirements) return '-'
      const ages = String(this.form.ageRequirements).split(',')
      if (ages.length >= 2) return `${ages[0].trim()} - ${ages[1].trim()}岁`
      return `${this.form.ageRequirements}岁`
    }
  },
  methods: {
    sanitizeRichText,
    /** 信用分圆形进度条中间文案：信用分 + 数值，无百分号 */
    formatCreditScore (percent) {
      const score = this.form.userCreditScore
      const num = score != null && score !== '' ? String(score) : (percent != null ? String(percent) : '-')
      return `信用分\n${num}`
    },
    isVideo (filePath) {
      if (!filePath) return false
      return filePath.toLowerCase().endsWith('.mp4')
    },
    previewImage (imageUrl) {
      if (!imageUrl) return
      window.open(imageUrl, '_blank')
    },
    onClose () {
      this.open = false
      this.showMediaModal = false
    },
    cancel () {
      this.open = false
      this.showMediaModal = false
      this.reset()
    },
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        type: null,
        status: 0,
        title: null,
        picture: null,
        content: null,
        category: null,
        categoryName: null,
        longitude: null,
        latitude: null,
        provinceCode: null,
        cityCode: null,
        areaCode: null,
        workLocation: null,
        address: null,
        pricingMethod: null,
        workStartTime: null,
        workEndTime: null,
        workTime: null,
        invoicing: null,
        invoiceId: null,
        invoicePicture: null,
        platformInvoicingPicture: null,
        money: null,
        unit: null,
        perCapitaProduction: null,
        numberOfWorkers: null,
        genderRequirements: null,
        ageRequirements: null,
        discountAmount: null,
        payAmount: null,
        payType: null,
        payTime: null,
        watchNum: null,
        createTime: null,
        remark: null,
        userName: null,
        userAvatar: null,
        userNickname: null,
        userMobile: null,
        userCreditScore: null,
        userCommentScore: null,
        insuranceInfo: null,
        man: null,
        woman: null,
        startWorkIfUnderstaffed: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    handleAdd () {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : (Array.isArray(ids) ? ids[0] : ids)
      if (id == null) {
        this.$message.warning('请选择一条记录')
        return
      }
      getOrder({ id }).then(response => {
        this.form = { ...this.form, ...response.data }
        this.open = true
        this.formTitle = '订单详情'
        if (this.form.userId) {
          getBizUser({ id: this.form.userId }).then(userRes => {
            const u = userRes.data
            if (u) {
              this.form.userName = u.nickname
              this.form.userAvatar = u.avatar
              this.form.userNickname = u.nickname
              this.form.userMobile = u.mobile
              this.form.userCreditScore = u.creditScore != null ? Number(u.creditScore) : null
              const commentScore = u.commentScore != null ? u.commentScore : u.comment_score
              this.form.userCommentScore = commentScore != null && commentScore !== '' ? Number(commentScore) : null
              this.form.contactPersonName = u.contactPersonName
              this.form.contactPersonPhone = u.contactPersonPhone
            }
          }).catch(() => {})
        }
      })
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        updateOrder({
          id: this.form.id,
          status: this.form.status
        }).then(response => {
          this.$message.success('修改成功', 3)
          this.$emit('ok')
        }).finally(() => {
          this.submitLoading = false
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.order-detail-wrap {
  padding-bottom: 24px;
}

.order-status-step {
  margin-bottom: 24px;
  padding: 16px;
  background: #fafafa;
  border-radius: 4px;
}

.order-info-card {
  background: #f5f5f5;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 16px;
}

.order-info-card--employer {
  padding-left: 18px;
}

.order-info-card__title {
  font-size: 15px;
  font-weight: 600;
  color: #000;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e8e8e8;
}

.employer-row .detail-row { margin-bottom: 4px; }
.employer-row .detail-row:last-child { margin-bottom: 0; }

.employer-row > .ant-col:first-child { padding-left: 0 !important; }

.employer-col--avatar { display: flex; justify-content: flex-start; }
.employer-col--credit { display: flex; align-items: center; }
.employer-col--rate { margin-left: -50px; }

.employer-avatar {
  cursor: pointer;
  border-radius: 4px;
}

.employer-avatar--placeholder {
  background: #d9d9d9;
  color: #fff;
  font-size: 24px;
}

.detail-row { display: flex; align-items: flex-start; margin-bottom: 8px; line-height: 1.6; min-width: 0; }
.detail-row--align-center { align-items: center; }
.detail-row--block { display: block; }
.detail-row--block .detail-label { display: block; margin-bottom: 4px; }

.detail-label {
  flex-shrink: 0;
  font-weight: bold;
  color: #000;
  font-size: 13px;
  margin-right: 4px;
}

.detail-value {
  color: #262626;
  font-size: 13px;
  min-width: 0;
}

.detail-value--ellipsis {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.employer-rate-wrap {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

/* 自定义星级展示（不依赖 a-rate，保证始终可见） */
.employer-rate-stars {
  display: inline-flex;
  align-items: center;
  font-size: 18px;
  line-height: 1;
  margin-right: 4px;
  vertical-align: middle;
}

.employer-rate-star {
  display: inline-block;
  margin-right: 2px;
}

.employer-rate-stars .star-full,
.employer-rate-stars .star-half,
.employer-rate-stars .star-empty {
  color: #fadb14;
}

.employer-rate-stars .star-empty {
  color: #e8e8e8;
}

.employer-rate-stars .star-half {
  display: inline-block;
  width: 0.5em;
  overflow: hidden;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px 24px;
  margin-bottom: 16px;
}

.detail-grid .detail-row { margin-bottom: 0; }

.content-desc-block {
  width: 100%;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.order-detail-content {
  font-size: 12px;
  color: #595959;
  line-height: 1.6;
  max-height: 200px;
  overflow-y: auto;
}

.order-detail-content /deep/ img {
  max-width: 100%;
  height: auto;
}

.order-detail-media { margin-bottom: 16px; }

.invoice-img-wrap { margin-bottom: 12px; }
.invoice-label { display: block; font-size: 12px; color: #8c8c8c; margin-bottom: 4px; }
.invoice-img {
  max-width: 240px;
  max-height: 320px;
  object-fit: contain;
  border-radius: 4px;
  border: 1px solid #e8e8e8;
  cursor: pointer;
}

.order-detail-footer {
  border-top: 1px solid #f0f0f0;
  padding-top: 16px;
  margin-top: 8px;
}
</style>
